import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "signInPage" };
const _hoisted_2 = { class: "waField" };
const _hoisted_3 = { class: "waFieldValue" };
const _hoisted_4 = { class: "waActions" };
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useWhatsApp } from '@/composables/useWhatsApp';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import { isSignInTest } from '@/utils/helpers';
// signUpStageReached 3 is webComplete; anything higher is a returning member, who goes
// straight into the app rather than on to linking an account.
const WEB_COMPLETE = 3;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInWhatsAppPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { enableWhatsApp } = useWhatsApp({ whatsAppPromoCard: null, whatsAppEnableDrawer: null, whatsAppNumber: '' });
        /* Bundled with the app rather than fetched from LottieFiles' CDN, so it works offline */
        DotLottie.setWasmUrl(require('@lottiefiles/dotlottie-web/dotlottie-player.wasm'));
        const lottieCanvas = ref(null);
        let player = null;
        function onLoad() {
            getCustomer(() => {
                // Nothing to ask: already on WhatsApp, or no number to message
                if ((state.customer?.person?.whatsAppEnabled && !isSignInTest()) || !state.customer?.person?.mobilePhone) {
                    router.replace({ path: nextPath() });
                }
            });
        }
        function enable() {
            enableWhatsApp();
            router.push({ path: nextPath() });
        }
        function skip() {
            router.push({ path: nextPath() });
        }
        function nextPath() {
            return (state.customer?.signUpStageReached ?? 0) > WEB_COMPLETE && !isSignInTest() ? '/' : '/linkopenbankingaccount';
        }
        onMounted(() => {
            onLoad();
            if (lottieCanvas.value)
                player = new DotLottie({ canvas: lottieCanvas.value, src: require('@/assets/onboarding/whatsapp-animation.lottie'), autoplay: true, loop: false });
        });
        onBeforeUnmount(() => player?.destroy());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: 0,
                    transparent: true
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("canvas", {
                        ref_key: "lottieCanvas",
                        ref: lottieCanvas,
                        class: "waIllustration"
                    }, null, 512),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "waCopy" }, [
                        _createElementVNode("h1", { class: "waTitle" }, [
                            _createTextVNode("Get support on"),
                            _createElementVNode("br"),
                            _createTextVNode("WhatsApp")
                        ]),
                        _createElementVNode("p", { class: "waSubtitle" }, "Wherever you are, whenever you need help, drop the digital financial assistant a message on WhatsApp.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createElementVNode("label", null, "Mobile number*", -1)),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(state).customer?.person?.mobilePhone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "waConsent" }, [
                            _createTextVNode("By continuing, you’re happy for Money Guided to reply to your messages on WhatsApp."),
                            _createElementVNode("br"),
                            _createTextVNode("WhatsApp handles messages under its own privacy policy.")
                        ], -1)),
                        _createVNode(MGButton, {
                            text: "Continue with WhatsApp",
                            stacked: true,
                            arrow: true,
                            fullWidth: true,
                            onClick: enable
                        }),
                        _createVNode(MGButton, {
                            text: "Not now",
                            noCaps: true,
                            stacked: true,
                            fullWidth: false,
                            onClick: skip,
                            outline: false,
                            transparent: true
                        })
                    ])
                ])
            ], 64));
        };
    }
});
